<template>
  <v-app>
    <v-main style="background-color: white">
      <sds-layout :loading="loading" class="fill-height">
        <router-view />
      </sds-layout>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import '@/styles/global.scss';
import { useLoader } from '@/composables/useLoader';
import PesquisaSatisfacaoService from '@/services/PesquisaSatisfacaoService';

import { Component, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  get loading() {
    const { loading } = useLoader();
    return loading.value;
  }

  async mounted() {
    const widgetCode = await PesquisaSatisfacaoService.getWidgetCode();
    if (widgetCode) {
      const script = document.createElement('script');
      script.text = widgetCode;
      document.head.appendChild(script);
    }
  }
}
</script>
